import React from 'react';
import { Calendar, MapPin, TrendingUp } from 'lucide-react';

const Experience = ({ data }) => {
  return (
    <section id="experience" className="experience-section">
      <div className="experience-container">
        <div className="section-header">
          <span className="label">PROFESSIONAL JOURNEY</span>
          <h2 className="title-big">EXPERIENCE</h2>
        </div>

        <div className="experience-timeline">
          {data.map((exp, index) => (
            <div key={exp.id} className="timeline-item">
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                {index < data.length - 1 && <div className="marker-line"></div>}
              </div>

              <div className="timeline-content">
                <div className="experience-card">
                  <div className="card-header">
                    <div className="company-info">
                      <h3 className="text-regular">{exp.company}</h3>
                      <span className="role text-body">{exp.role}</span>
                    </div>
                    <div className="duration-info">
                      <div className="info-item">
                        <Calendar size={16} />
                        <span className="label-small">{exp.period}</span>
                      </div>
                      <div className="info-item">
                        <MapPin size={16} />
                        <span className="label-small">{exp.location}</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-body experience-description">
                    {exp.description}
                  </p>

                  <div className="achievements-section">
                    <div className="achievements-header">
                      <TrendingUp size={16} />
                      <span className="label-small">KEY ACHIEVEMENTS</span>
                    </div>
                    <ul className="achievements-list">
                      {exp.achievements.map((achievement, idx) => (
                        <li key={idx} className="text-body">{achievement}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="technologies">
                    <span className="label-small">TECHNOLOGIES</span>
                    <div className="tech-tags">
                      {exp.technologies.map((tech, idx) => (
                        <span key={idx} className="tech-tag label-small">{tech}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;